(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('morningFlightAfterNightFlight', [
      'ui.router'
    ]);
}());
